import React from 'react';
import ReactGA from 'react-ga';
import { ErrorSection } from './components';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (error) {
      ReactGA.event({
        category: 'Error: Web',
        action: error.toString(),
        label: errorInfo?.componentStack?.toString(),
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorSection />;
    }

    return this.props.children;
  }
}
